// Version : 0.0.1
// Author : AGALYA

import ActiveMemberActionTypes from './active-member.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getActiveMemberListResponse: null,
	getActiveMemberListArr: [],
};

const activeMemberReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET ACTIVE MEMBER START *********************** */
		case ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getActiveMemberListResponse: action.payload,
				getActiveMemberListArr: docodeHexResponse(
					action.payload,
					'GetActiveMemberReportKey',
				),
			};

		case ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_FAILURE:
			return {
				...state,
				getActiveMemberListResponse: action.payload,
				getActiveMemberListArr: [],
			};

		case ActiveMemberActionTypes.GET_ACTIVE_MEMBER_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getActiveMemberListResponse: action.payload,
			};

		/** ***************** GET ACTIVE MEMBER START *********************** */

		default:
			return state;
	}
};

export default activeMemberReportReducer;
